import { render, staticRenderFns } from "./ApRecycleDetail.vue?vue&type=template&id=3cd6284c&scoped=true&"
import script from "./ApRecycleDetail.vue?vue&type=script&lang=js&"
export * from "./ApRecycleDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApRecycleDetail.vue?vue&type=style&index=0&id=3cd6284c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd6284c",
  null
  
)

component.options.__file = "ApRecycleDetail.vue"
export default component.exports